import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
  output,
} from '@angular/core';

import { FaIconComponent } from '../../atoms';
import { ButtonComponent } from '../button/button.component';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faPlus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'orbit-form-field-header',
  standalone: true,
  imports: [ButtonComponent, FaIconComponent],
  templateUrl: './form-field-header.component.html',
  styleUrl: './form-field-header.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldHeaderComponent {
  label = input<string>();
  tooltip = input<string>('');
  icon = input<IconProp>(faPlus);
  button = input<boolean>(false);
  buttonClick = output<boolean>();

  questionMark = faQuestionCircle;

  onButtonKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.buttonClick.emit(true);
    }
  }
}
